import React from 'react';

import { EmptyState } from '@/components/atoms/EmptyState';

interface Props {
  readonly title: string;
  readonly message: string;
  readonly children?: React.ReactNode;
}

export const NoResultsView: React.FC<Props> = ({
  title,
  message,
  children,
}: Props): React.ReactElement => {
  return (
    <EmptyState.Container>
      <EmptyState.Title>{title}</EmptyState.Title>
      <EmptyState.Message>{message}</EmptyState.Message>
      {children && <EmptyState.Actions sx={{ mt: 2 }}>{children}</EmptyState.Actions>}
    </EmptyState.Container>
  );
};
